// extracted by mini-css-extract-plugin
module.exports = {"article":"EncyclopediaArticle_article__qD1JE","author-contact":"EncyclopediaArticle_author-contact__ZZ0WX","more-articles":"EncyclopediaArticle_more-articles___mv8Z"};